import { DirectiveOptions } from 'vue';

const events = ['click'];

function onClickOutside({ event, el, handler, middleware }: any) {
  const isClickOutside = event.target !== el && !el.contains(event.target);

  if (!isClickOutside || !middleware(event, el)) {
    return null;
  }

  return handler(event, el);
}

const instances = new Map();

//Requires loop to toggle events for several listeners of an element
function toggleEventListeners(eventHandlers: any) {
  return (action: any) => {
    eventHandlers.forEach(({ event, handler }: any) => {
      // @ts-expect-error: Element implicitly has an 'any' type because expression of type '`${any}EventListener`' can't be used to index type 'Document'
      document[`${action}EventListener`](event, handler, true);
    });
  };
}

//Validator function
function processArgs(value: any) {
  const isFunction = typeof value === 'function';

  if (!isFunction && typeof value !== 'object') {
    throw new Error(
      `v-click-outside: Binding value should be a function or an object, ${typeof value} given`
    );
  }

  return {
    handler: isFunction ? value : value.handler,
    middleware: value.middleware || (() => true),
  };
}

//Now need adapter to handle several events for one Map element
function eventAdapter(events: any, { el, handler, middleware }: any) {
  return events.map((eventName: any) => ({
    event: eventName,
    handler: (event: any) => onClickOutside({ event, el, handler, middleware }),
  }));
}

const directive: DirectiveOptions = {
  bind(el, { value }) {
    const { handler, middleware } = processArgs(value);
    const eventHandlers = eventAdapter(events, { el, handler, middleware });

    instances.set(el, eventHandlers);

    toggleEventListeners(eventHandlers)('add');
  },
  unbind(el) {
    const eventHandlers = instances.get(el);

    toggleEventListeners(eventHandlers)('remove');

    instances.delete(el);
  },
};
export default directive;
